import React from 'react';

import { FormattedMessage } from '../../../util/reactIntl';
import { ModalPortal, ShareViaSocialNetworkButtons } from '../../../components';

import css from '../ListingPage.css';
import { createSlug } from '../../../util/urlHelpers';

const windowIsDefined = typeof window !== 'undefined'; // for ssr

const SharingViaSocialNetworkModal = ({
    isOpen,
    onCloseEnquiryModal,
    emailSharingDescription,
    listing,
    slug: slugFromProps,
}) => {
    const {
        id: { uuid: listingId },
        attributes: { title = '' },
    } = listing;

    const slug = slugFromProps || createSlug(listing);

    const origin = windowIsDefined ? window.location.origin : 'https://www.horsedeal.com';
    const shareLink = `${origin}/l/${slug}/${listingId}`;
    const emailShareSubject = `${title} auf HorseDeal 💜`;
    /** %0D%0A new line enc */
    const emailBody = `${emailSharingDescription}%0D%0A%0D%0AHier der Link: ${
        windowIsDefined ? window.location.href : ''
    }`;

    const sharingProps = {
        shareLink,
        subjectMail: emailShareSubject,
        subjectBody: emailBody,
        waText: emailBody,
    };

    return (
        <ModalPortal
            id={`SocialNetworks.share.${listingId}`}
            containerClassName={css.shareModalContainer}
            isOpen={isOpen}
            onClose={onCloseEnquiryModal}
        >
            <div>
                <div className={css.modalHeader}>
                    <FormattedMessage id="SocialNetworkSharing.shareList" />
                </div>
                <p className={css.modalSubHeader}>
                    Erzähle deinen Freunden davon und hilf uns dabei, unsere Community aufzubauen.{' '}
                </p>
                <ShareViaSocialNetworkButtons {...sharingProps} />
            </div>
        </ModalPortal>
    );
};

export default SharingViaSocialNetworkModal;
